import request from '../../graphql/request';
import {
  FETCH_PROJECTS,
  UPDATE_PROJECT,
  CREATE_PROJECT,
  SEND_EMAIL_NOTIFICATION,
  FILTER_PROJECTS,
  FETCH_PROJECT_DETAILS,
  PROP_CLOSING_CATGS,
  FETCH_PROJECT_STATUS,
  FETCH_STORE_DETAILS,
  FETCH_STORE_DETAILS_BY_COMPANY,
  UNLOCK_PROJECT,
  LOCK_PROJECT,
  CLOSE_PROJECT,
  CONDITIONALLY_CLOSE_PROJECT,
  DROP_PROJECT,
  GET_LATEST_PROJECT_STATUS,
  GET_PROJECT_STATUS_HISTORY,
  FETCH_BULK_PROJECT_DETAILS,
  EXPORT_BULK_COMMENTS,
  FETCH_RECIPIENTS_BY_PROJECT,
  FETCH_PROJECT_EMAIL_NOTIFICATION_HISTORY
} from './queries';

export const fetchProjects = variables =>
  request({
    query: FETCH_PROJECTS,
    variables
  });

export const createProject = variables =>
  request({
    query: CREATE_PROJECT,
    variables
  });

export const updateProject = variables =>
  request({
    query: UPDATE_PROJECT,
    variables
  });

export const unlockProject = variables =>
  request({
    query: UNLOCK_PROJECT,
    variables
  });

export const lockProject = variables =>
  request({
    query: LOCK_PROJECT,
    variables
  });

export const closeProject = variables =>
  request({
    query: CLOSE_PROJECT,
    variables
  });

export const conditionallyCloseProject = variables =>
  request({
    query: CONDITIONALLY_CLOSE_PROJECT,
    variables
  });

export const dropProject = variables =>
  request({
    query: DROP_PROJECT,
    variables
  });

export const filterProjects = variables =>
  request({
    query: FILTER_PROJECTS,
    variables
  });

export const fetchProjectDetailsById = variables =>
  request({
    query: FETCH_PROJECT_DETAILS,
    variables
  });

export const fetchProjectCatogiriesByProjId = variables =>
  request({
    query: PROP_CLOSING_CATGS,
    variables
  });


export const fetchAllClosingStatus = variables =>
  request({
    query: FETCH_PROJECT_STATUS,
    variables
  });

export const fetchStoreDetails = variables =>
  request({
    query: FETCH_STORE_DETAILS,
    variables
  });

export const fetchStoreDetailsByCompany = variables =>
  request({
    query: FETCH_STORE_DETAILS_BY_COMPANY,
    variables
  });

export const getLatestProjectStatus = closing_id =>
  request({
    query: GET_LATEST_PROJECT_STATUS,
    variables: { closing_id }
  });

export const getProjectStatusHistory = variables =>
  request({
    query: GET_PROJECT_STATUS_HISTORY,
    variables
  });

// Bulk Reports APIs
export const fetchBulkProjectDetails = variables =>
  request({
    query: FETCH_BULK_PROJECT_DETAILS,
    variables
  });

export const exportBulkComments = variables =>
  request({
    query: EXPORT_BULK_COMMENTS,
    variables
  });
export const fetchRecipientsByProject = variables =>
  request({
    query: FETCH_RECIPIENTS_BY_PROJECT,
    variables
  });

export const fetchProjectEmailNotificationHistory = variables =>
  request({
    query: FETCH_PROJECT_EMAIL_NOTIFICATION_HISTORY,
    variables
  });

export const sendEmailNotification = variables =>
  request({
    query: SEND_EMAIL_NOTIFICATION,
    variables
  });
